// import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectViews } from 'store/UI/UITypes'
import { ProjectState } from '../../../store/Project/ProjectTypes'

export const projectInitialState: ProjectState = {
  currentView: ProjectViews.DashboardView,
  activeProject: undefined,
  flatView: undefined,
  treeView: undefined,
  priceSummaries: undefined,

  assemblyHeadersIds: [],
  materialHeadersIds: [],
  assemblyStructuresIds: [],
  structurePartTypeIds: [],
  partTypeIds: [],
  routingHeadersIds: [],

  projectOperations: {
    shallUpdateSummary: true,
    shallUpdateOperations: true,
  },

  searchedBomItemId: undefined,

  selectedBomItemIds: [],
  selectedHeaderIds: [],
  operationPending: false,
  currentOperations: {},
  focusedBomItemId: undefined,

  filters: {
    byWorkingStep: {
      filter: {
        type: 'WorkingStepsFilter',
        availableFilters: [],
        enabledFilters: [],
        disabledFilters: [],
      },
      active: false,
    },
    byMaterialKeywords: {
      filter: {
        type: 'MaterialKeywordsFilter',
        disabledFilters: undefined,
        enabledFilters: undefined,
        availableFilters: undefined,
      },
      active: false,
    },
    byIssues: {
      filter: {
        type: 'IssuesFilter',
        disabledFilters: [],
        availableFilters: undefined,
      },
      active: false,
    },
    byPartTypeId: {
      filter: {
        type: 'PartTypeIdFilter',
        enabledFilters: [],
      },
      active: false,
    },
    byArticleId: {
      filter: {
        type: 'ArticleIdFilter',
        enabledFilters: [],
      },
      active: false,
    },
    byResourceId: {
      filter: {
        type: 'ResourceIdFilter',
        enabledFilters: [],
      },
      active: false,
    },
    byManufacturability: {
      filter: {
        type: 'ManufacturabilityCheckFilter',
        manufacturabilityStatus: undefined,
      },
      active: false,
    },
  },
}
